import { Box, Grid, Typography, TextField } from "@mui/material";
import profile_image from "../../assets/images/ajit_image.jpeg";
import styles from "../../screens/Dashboard/Dashboard.module.css";
import { customTextColor } from "../../utils/const";
import { CreditCard } from "@mui/icons-material";
import { FaUser } from "react-icons/fa";
const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "55px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "55px", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "10px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "55px", // Adjust label position when it shrinks
  },
  // padding: "10px",
};

const DashboardCredit = () => {
  return (
    <>
      <Box className={styles.credit_profile}>
        <div>
          <img src={profile_image} alt="Profile" />
          <span style={{ color: customTextColor }}>
            <Typography>
              Recruiter: <b>Ashit Kumar Rout</b>
            </Typography>
            <Typography>
              Designation: <b>Sr. Recruiter</b>
            </Typography>
            <Typography>
              Company: <b>Dinkins Solutions Pvt Ltd</b>
            </Typography>
          </span>
        </div>
        <span style={{ alignSelf: "flex-end" }}>
          <button style={{ backgroundColor: "#00a349" }}>
            Transfer Credit
          </button>
        </span>
      </Box>
      <Box sx={{ backgroundColor: "#fff", margin: "14px " }}>
        <Grid container>
          <Grid item xs={12} sm={6} sx={{ padding: "20px" }}>
            <Box
              className={styles.company_credit_box}
              sx={{ color: customTextColor }}
            >
              <Typography>
                {" "}
                <b>25000 </b>
              </Typography>

              <Typography>Available Credit</Typography>

              <span>Last transaction 12 June 2024</span>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} sx={{ padding: "20px" }}>
            <Box sx={{ textAlign: "center" }}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  sx={{ padding: "20px 10px 10px 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <CreditCard style={{ fontSize: "35px" }} />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Credit "
                    variant="standard"
                    sx={fieldStyle}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  sx={{ padding: "20px 10px 10px 10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <FaUser style={{ fontSize: "30px" }} />
                  </Box>
                  <TextField label=" ID" variant="standard" sx={fieldStyle} />
                </Grid>
              </Grid>

              <button className={styles.pay_credit_btn}>Transfer</button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default DashboardCredit;
